import { cn } from "@/lib/utils";
import type { CreateParameterFormData } from "@/types/parameter/parameter";

export const getInputClass = (parameter: CreateParameterFormData) => {
	return cn(
		"bg-soft-white dark:bg-black text-gray-500 dark:text-gray-400",
		parameter.isAltered &&
			"border-mustard focus-visible:border-mustard bg-white dark:bg-black text-black dark:text-white",
		parameter.error && "!border-destructive"
	);
};
